import { Table, Typography } from "@pankod/refine-antd";
import { EMedia } from "constants/constant";
import { ICallDetail } from "interfaces/callReport";
import { convertSecondsToTime, formatNumber } from "utils";

type BillItemsTableProps = {
  recordApptDetail: ICallDetail;
};
const { Title } = Typography;
export const BillItemsTable = (props: BillItemsTableProps) => {
  const { recordApptDetail } = props;

  const dataSource = [
    {
      name: `${
        recordApptDetail?.media === EMedia.VIDEO ? EMedia.VIDEO : EMedia.AUDIO
      }`,
      quantity: `${
        recordApptDetail?.duration
          ? `${convertSecondsToTime(recordApptDetail?.duration)}`
          : ""
      }`,
      rate: `${recordApptDetail?.rateBill || ""}`,
      ratio: `${recordApptDetail?.ratioBill}`,
      total: `${
        recordApptDetail?.totalBillPreTaxAmount
          ? `$${formatNumber(recordApptDetail?.totalBillPreTaxAmount)}`
          : `$0`
      }`,
    },
  ];

  const columns = [
    {
      title: "Item Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
    },

    {
      title: "Ratio",
      dataIndex: "ratio",
      key: "ratio",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
    },
  ];

  return (
    <div className="requester-information">
      <Title level={5}>Bill Items</Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        summary={() => (
          <Table.Summary>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={4}>
                <b>Pre-tax Amount</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <b>
                  {recordApptDetail?.totalBillPreTaxAmount
                    ? `$${formatNumber(
                        recordApptDetail?.totalBillPreTaxAmount
                      )}`
                    : `$0`}
                </b>
              </Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={4}>
                <b>Tax</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <b>
                  {recordApptDetail?.totalBillTaxed
                    ? `$${formatNumber(recordApptDetail?.totalBillTaxed)}`
                    : `$0`}{" "}
                </b>{" "}
              </Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={4}>
                <b>Total</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                {" "}
                <b>
                  {recordApptDetail?.totalBill
                    ? `$${formatNumber(recordApptDetail?.totalBill)}`
                    : `$0`}
                </b>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        scroll={{ x: 800 }}
      />
    </div>
  );
};

export default BillItemsTable;
